module.exports = __webpack_public_path__ + "static/img/ofu.475564b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companys/ofu.jpg
// module id = 9s3F
// module chunks = 0